<template>
<v-text-field 
 v-model="localvalue"
 @input="value => Change(value)"> <!--ESTO DA EL VALOR-->
 ></v-text-field>
    
</template>
<script>
const props = {
    value:{
        default: '',
        type: String
    },
}

export default {
    data (){
        return{
            localvalue: this.value
        }
    },
    props: props,
     methods: {
        Change(prop){
            this.$emit('input', prop)
        }
    }
}
</script>
<style scoped>

</style>
